import {showRulebookPopup} from '../../../shared/scripts/ui_rulebook/UIRulebookPopupGlobal'
import {UIWFooterController} from './UIWFooterController'

export class UIDFooterController extends UIWFooterController {
    constructor() {
        super()

        for(const button of this.rulesButtons) {
            button.onclick = () => showRulebookPopup()
        }
    }

    activateAboutButton() {
        this.deactivateAllButtons()
        for(const button of this.aboutButtons) {
            button.classList.add('active')
        }
    }

    activateCareersButton() {
        this.deactivateAllButtons()
        for(const button of this.careersButtons) {
            button.classList.add('active')
        }
    }

    activateCommunityButton() {
        this.deactivateAllButtons()
        for(const button of this.communityButtons) {
            button.classList.add('active')
        }
    }

    activateFAQButton() {
        this.deactivateAllButtons()
        for(const button of this.faqButtons) {
            button.classList.add('active')
        }
    }

    activatePrivacyPolicyButton() {
        this.deactivateAllButtons()
        for(const button of this.privacyPolicyButtons) {
            button.classList.add('active')
        }
    }

    deactivateAllButtons() {
        const allButtons = [...this.aboutButtons, ...this.careersButtons, ...this.communityButtons, ...this.faqButtons, ...this.privacyPolicyButtons]
        for(const button of allButtons) {
            button.classList.remove('active')
        }
    }
}
